
import Modal from '../../modal/src/base'
import Panel from '../../panel/src/panel'

import { foreignProps } from 'vessel/utils'

const modal = foreignProps(Modal)
const panel = foreignProps(Panel, {
  except: ['scrollable'],
  defaults: {
    background: 'white',
    border: true,
    shadow: true
  }
})

const sizes = {
  mini:   '16rem',
  small:  '20rem',
  medium: '24rem',
  large:  '40rem'
}

export default {
  name: 'VsDrawer',
  model: {
    prop: 'visible',
    event: 'update:visible'
  },
  props: {
    ...modal.props,
    ...panel.props,
    closeOnSwipe: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'right'
    },
    visible: {
      type: Boolean,
      default: false
    },
    button: {
      type: [String, Boolean, Object],
      default: null
    },
    buttonIcon: {
      type: [Boolean, String, Object],
      default: null
    },
    buttonText: {
      type: [Boolean, String, Object],
      default: null
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue != oldValue) {
          newValue ? this.open() : this.close()
        }
      }
    }
  },
  data() {
    return {
      isVisible: false
    }
  },
  computed: {
    modalAttrs() {
      const vertical = ['top', 'bottom'].includes(this.position)
      const startPos = ['left', 'top'].includes(this.position)

      const attrs = { sizes, width: 'full', height: 'full' }
      const align = startPos ? 'start' : 'end'
      const props = modal.fetch(this.$props)

      if (vertical) {
        attrs.align    = align
        attrs.sizeProp = 'height'
      } else {
        attrs.justify  = align
        attrs.sizeProp = 'width'
      }

      return { ...props, ...attrs }
    },
    panelAttrs() {
      return panel.fetch(this.$props)
    },
    animate() {
      const leave = { top: 'up', bottom: 'down' }
      const enter = { top: 'down', bottom: 'up' }
      const value = this.position

      return {
        name: 'slide',
        duration: 'faster',
        enter: enter[value] || value,
        leave: leave[value] || value,
      }
    }
  },
  methods: {
    open() {
      this.$drawer.toggleButtons(true)
      this.isVisible = true

      this.$emit('open')
      this.$emit('update:visible', true)
    },
    close() {
      this.isVisible = false

      this.$emit('close')
      this.$emit('update:visible', false)
    },
    toggle() {
      this.isVisible ? this.close() : this.open()
    },
    onEnter() {
      if (this.name) {
        this.$drawer.active = this.name
      }
    },
    onLeave() {
      this.$drawer.toggleButtons(false)

      if (this.name && this.$drawer.active == this.name) {
        this.$drawer.active = null
      }
    },
    onSwipe(position) {
      if (!this.closeOnSwipe) return

      const classList = ['dragging', 'is-dragging']
      const draggable = (el) => el && classList.some(cl => el.classList.contains(cl))

      return (direction, { target }) => {
        if (direction == position && !draggable(target)) {
          this.close()
        }
      }
    }
  },
  mounted() {
    if (this.name) {
      this.$drawer.register(this.name, this)
    }
  },
  destroyed() {
    if (this.name) {
      this.$drawer.unregister(this.name)
    }
  }
}
